export const getError = state => state.tags.error;
export const getTagsList = state => state.tags.tagsList;



// WEBPACK FOOTER //
// ./src/selectors/tagSelectors.js